"use client";

import { motion, useReducedMotion } from "framer-motion";
import { marketingMotion } from "@/lib/motion/config";

interface IMotionSectionProps {
  children: React.ReactNode;
  className?: string;
  ariaLabel?: string;
  id?: string;
}

export function MotionSection({
  children,
  className,
  ariaLabel,
  id,
}: IMotionSectionProps): React.ReactElement {
  const prefersReducedMotion = useReducedMotion();

  return (
    <motion.section
      id={id}
      className={className}
      aria-label={ariaLabel}
      initial={{ opacity: 0, y: prefersReducedMotion ? 0 : 10 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={marketingMotion.viewport}
      transition={{
        duration: marketingMotion.duration.base,
        ease: marketingMotion.easing.smooth,
      }}
    >
      {children}
    </motion.section>
  );
}
